// extracted by mini-css-extract-plugin
export default {"diameter":"35vmax","aurora":"TransactionDialog_aurora__-E8pI","hue":"TransactionDialog_hue__FdgG+","move1":"TransactionDialog_move1__OMK8-","move2":"TransactionDialog_move2__O4Fjm"};